import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { IconButton, Popover, Slider } from '@mui/material';

export const StyledAudioPlayer = styled('div')`
  height: 76px;
  width: 100%;
  box-sizing: border-box;

  .audio-progress-bar {
    height: 4px;
    width: 100%;
    background-color: ${COLOR.secondary[24]};
    opacity: 0.4;
  }

  .audio-control-panel {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px 24px 0px 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .audio-timer {
      padding: 0px 12px;
      box-sizing: border-box;
      width: 35%;
      .project-title {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.4px;
        color: ${COLOR.darkGray};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .timer {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.4px;
        vertical-align: middle;
        color: #1c1c1ea3;
      }
    }

    .audio-control {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      .disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }

      .audio-control-icon {
        padding: 8px;
        box-sizing: border-box;

        .button-active {
          background-color: ${COLOR.secondary[80]};
        }
      }
    }

    .audio-config {
      display: flex;
      align-items: end;
      padding: 0px 12px;
      width: 35%;

      justify-content: flex-end;

      .audio-config-icon {
        padding: 8px;
        .disabled {
          cursor: not-allowed;
          opacity: 0.4;
        }
        .audio-config-icon-loading {
          color: #1e164e;
        }
      }
    }
  }

  .audio-control-loading-container {
    background-color: #ffd60a;
    margin: 8px;
    cursor: pointer;
    color: #1e164e;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    .audio-control-loading {
      color: #1e164e;
      width: 24px;
      height: 24px;
    }
  }

  .audio-control-icon-pause,
  .audio-control-icon-play {
    cursor: pointer;
    color: #1e164e;
    background-color: #ffd60a;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    padding: 8px;
    box-sizing: border-box;
  }
  .convert-icon {
    cursor: pointer;
    color: #1e164e;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
  }
`;

export const StyledVolume = styled(Popover)`
  .MuiPaper-root {
    border-radius: 100px;
  }

  .volume-wrapper {
    display: flex;
    height: 200px;
    padding: 12px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    gap: 3px;
  }
`;

export const StyledSlider = styled(Slider)`
  color: ${COLOR.primary};
  height: 150px;

  & .MuiSlider-valueLabel {
    font-weight: bold;
    font-size: 14px;
    top: -8px;
    background-color: unset;
    color: ${COLOR.text};

    &:before {
      display: none;
    }
  }

  & .MuiSlider-thumb {
    height: 14px;
    width: 14px;
    background-color: ${COLOR.white};
    border: 1px solid currentColor;
  }

  & .MuiSlider-rail {
    color: ${COLOR.secondary[24]};
  }
`;

export const StyledVolumeMixer = styled(Popover)`
  .MuiPaper-root {
    border-radius: 12px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    overflow: visible;
  }

  .mixer-wrapper {
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 12px;
    padding: 12px;
    background: ${COLOR.white};
    border-radius: 12px;
  }
`;

export const StyledMixerColumn = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 200px;
`;

export const StyledMixerIconButton = styled(IconButton)`
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 500px;
  color: ${COLOR.darkGray};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const StyledMixerSlider = styled(Slider)`
  flex: 1;
  width: 4px;
  padding: 0 !important;
  margin: 8px 0;
  color: ${COLOR.primary};

  & .MuiSlider-rail {
    background-color: rgba(30, 22, 78, 0.08);
    opacity: 1;
    width: 4px;
    border-radius: 12px;
  }

  & .MuiSlider-track {
    width: 4px;
    border: none;
    border-radius: 12px;
  }

  & .MuiSlider-thumb {
    width: 14px;
    height: 14px;
    background-color: ${COLOR.white};
    border: 1px solid ${COLOR.primary};

    &:hover,
    &.Mui-focusVisible,
    &.Mui-active {
      box-shadow: 0 0 0 6px rgba(255, 214, 10, 0.16);
    }
    &::after {
      height: auto !important;
      width: auto !important;
    }
  }
`;

export const StyledAudio = styled('div')`
  min-width: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledAudioSlider = styled(Slider)({
  height: 4,
  padding: '0px !important',

  '& .MuiSlider-track': {
    border: 'none',
  },

  '& .MuiSlider-thumb': {
    zIndex: 1000,
  },
  '& .MuiSlider-rail': {
    color: COLOR.secondary[24],
  },
});
